// extracted by css-extract-rspack-plugin
module.exports =  {"help":"Help-m__help___cig7e","danger":"Help-m__danger___XYIHD"};